/**
 * 公共接口实现方法
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 添加菜单
    async fetchIncreaseMenu({ commit, getters }, params) {
      const { increaseMenu } = getters.getHttps
      const { data } = await increaseMenu(params)
      return setStoreApiDate(data, commit)
    },
  }
}
